import axios from "axios";
import React, {useEffect, useState} from 'react'
import Header from "./parts/header";
import Footer from "./parts/footer";
import FirstScreen from "./first-screen/firstscreen-slider";
import Statistic from "./statistic/statistic";
import About from "./about/about";
import Themes from "./themes/themes-base";
import Advantages from "./advantages/advantages";
import CustomGallery from "./gallery/gallery";
import EventSpeacers from "./speacers/speacers-base"
import EventProgram from "./program/program-base"
import Formats from "./formats/formats";
import PartnersTopNew from "./partners/partners-top"
import PartnersCenter from "./partners/partners-center"
import Awarding from "./awarding/awarding";
import EventOrganizers from "./organizers/organizers"
import EventOldSpeakersBase from "./speacers/speacers-old"

import EventPartnersBottom from "./partners/partners-bottom"
import EventProgramPreview from "./program/program-preview"

function Home() {

    const [post, setPosts] = useState([]);

    const fetchPosts = () => {
        axios
            .get('https://ekonomika.ua/wp-json/wp/v2/events/3721?_fields=acf&acf_format=standard')
            .then((res) => {
                setPosts(res.data.acf);
            });
    }

    useEffect(() => {
        fetchPosts()
    }, [post.data])

    console.log(post)

    let fsData = post.fs_group
    let aboutData = post.ebaut_event
    let themesData = post.theme
    let advantagesData = post.advantages
    let myGallery = post.gallery
    let speacersData = post.speacers
    let programData = post.program
    let formatsData = post.formats
    let partnersTopData = post.partners_top_new
    let partnersBaseData = post.partners_bottom
    let awardingData = post.awarding
    let panelData = post.panel
    
    return (
        <>
        
            <Header/>
            <FirstScreen fsData={fsData} />
            <Statistic />
            <PartnersTopNew partnersTopData={partnersTopData} />
            <About aboutData={aboutData} />
            <Themes themesData={themesData} />
            {/*<Advantages advantagesData={advantagesData} />*/}
            <EventSpeacers speacersData={speacersData} />
            {/* <EventOldSpeakersBase /> */}
            <PartnersCenter partnersBaseData={partnersBaseData} />
            <EventProgram programData={programData} />
            {/* <EventProgramPreview /> */}
            <CustomGallery myGallery={myGallery} />
            <Formats formatsData={formatsData} />
            <Awarding awardingData={awardingData} />
            {<EventOrganizers/>}
            <EventPartnersBottom partnersBaseData={partnersBaseData}/>
            <Footer />

        </>
    )
}

export default Home;